import { ExceptionApiAccessTokenExpired } from '~/data/exceptions/ExceptionApiAccessTokenExpired'

export const useErrorCaptured = () => {
  const { sendError } = useLoki()

  onErrorCaptured((error: any) => {
    if (error instanceof ExceptionApiAccessTokenExpired) {
      // todo 토큰 만료 임시처리
      navigateTo(URL_MAP.LOGOUT)
      return
    }

    sendError(error)

    showError({
      statusCode: EXCEPTION_STATUS_CODE.GENERAL,
      message: error.message,
    })
  })
}
